export const toCapitalized = (value: string): string =>
  value ? value[0].toUpperCase() + value.slice(1).toLowerCase() : value;

export const stringifyArrayWithCommas = (array: string[]): string => {
  const arrayCopy = [...array];

  if (arrayCopy.length > 1) {
    const lastElement = arrayCopy.pop();
    const secondLastElement = arrayCopy.pop();
    if (arrayCopy.length === 0) {
      return `${secondLastElement} and ${lastElement}`;
    } else {
      return `${arrayCopy.join(", ")}, ${secondLastElement} and ${lastElement}`;
    }
  }

  return array.join("");
};

export const pluralize = (count: number, word: string) => {
  return count === 1 ? word : `${word}s`;
};
